import {formatFilterLabelFromValue} from "./localFilterUtil";

function urlParamsUtil(urlParamsGetter, urlParams) {
    return urlParams.forEach((urlParams) => param(
        urlParamsGetter, 
        urlParams.isArray,
        urlParams.outsideUrlSetter, 
        urlParams.key, 
        urlParams.transformParamsFunc
    ))
}

function param(
    urlParamsGetter,
    isArray,
    outsideUrlSetter, 
    key, 
    transformParamsFunc,
) {
    if (isArray) {
        const params = urlParamsGetter.getAll(key);
        params && params.length ? outsideUrlSetter(
        transformParamsFunc(params)
        ) :
        // param size is 0 e.g. multi selects should have empty array value
        outsideUrlSetter([])
    } else {
        let param = urlParamsGetter.get(key);
        if (param && transformParamsFunc) {
            param = transformParamsFunc(param)
        }
        if (param)
            outsideUrlSetter(
                typeof param === 'string' ? param : param[0]
            )
    }
}

const filterSelect = (select) => {
    return (targetSelectItem) => {
        const transformSelect = select[0].group ? select.flatMap((selectGroup)=>{
            if(selectGroup?.group)
            {
                    return selectGroup?.items
            }
            return selectGroup
        }) : select;
        const selected =  transformSelect.filter((currentSelectItem) => targetSelectItem?.indexOf(currentSelectItem.value) !== -1);
        return selected?.length ? selected : [{value: targetSelectItem, label: formatFilterLabelFromValue(targetSelectItem)}]
    }
}

export {urlParamsUtil, filterSelect}